import { useLayoutEffect, useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { scrollPageTopInstant } from '../utils/scroll';

function shouldSkipWindowScrollReset(pathname, navType, hash) {
  if (navType === 'POP') return true;
  if (hash) return true;
  if (/^\/daiv-nitya(\/|$)/.test(pathname)) return true;
  return false;
}

/**
 * Scroll to top on route change (footer / nav links).
 * useLayoutEffect runs before paint; delayed + route-painted passes catch lazy/async content.
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (hash) {
      const id = hash.replace(/^#/, '');
      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return;
    }
    if (shouldSkipWindowScrollReset(pathname, navType, hash)) return;
    scrollPageTopInstant();
  }, [pathname, hash, key, navType]);

  useEffect(() => {
    if (shouldSkipWindowScrollReset(pathname, navType, hash)) return;

    /* One correction after lazy content paints. Extra timeouts yanked the page mid-fade. */
    const onPainted = () => scrollPageTopInstant();
    window.addEventListener('daiv-route-painted', onPainted);

    return () => {
      window.removeEventListener('daiv-route-painted', onPainted);
    };
  }, [pathname, hash, key, navType]);

  return null;
}
